import { render } from "./AtendimentosWhatsAppTriageView.vue?vue&type=template&id=7dba2108&scoped=true"
import script from "./AtendimentosWhatsAppTriageView.vue?vue&type=script&lang=js"
export * from "./AtendimentosWhatsAppTriageView.vue?vue&type=script&lang=js"

import "./AtendimentosWhatsAppTriageView.vue?vue&type=style&index=0&id=7dba2108&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dba2108"]])

export default __exports__